<div [hidden]="isEmptyData() && !initialDataExists">
  @if (!['protocolsamples','protocolfiles','protocolanalysis'].includes(target_type)) {
    <hr>
    }

    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center"
      style="margin: 20px 0 20px 0;">

      <h3>
        @if (target_type !== 'protocolsamples' && target_type !== 'protocolfiles' && target_type !== 'protocolanalysis') {
          <span>
            Related {{displayTitle(target_type)}}
          </span>
        }
        @if (isEuroFaangProj) {
          <span> for
            <span class="childproj-title">
              {{record_id}}
            </span>
          </span>
        }
      </h3>

      <div fxLayout="row" fxLayout.lt-md="column">
        @if (download_key.length > 0) {
          <button mat-raised-button color="accent"
            (click)="goToDownloader()"
            >
            Go to bulk downloader utility
          </button>
        }
        @if (download_key.length > 0 && mode === 'public') {
          <button mat-raised-button color="accent" (click)="downloadAllFiles()" [disabled]="urls.length === 0"
            >Download selected files ({{urls.length}})
          </button>
        }

        <div style="margin-left: 10px;">
          <mat-form-field>
            <mat-label>Column Selection</mat-label>
            <mat-select [(ngModel)]="display_fields" multiple>
              @for (col of get_all_fields(); track col; let i = $index) {
                <mat-option
                  [value]="col" [disabled]="i==0"> {{col}}
                </mat-option>
              }
              @if (download_key.length > 0) {
                <mat-option
                  value="Download" disabled="true"> Download
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

      </div>
    </div>

    <div class="table-responsive">
      <mat-form-field style="width: 100%;">
        <mat-label>Search</mat-label>
        <input (keyup)="searchChanged($event)" matInput
          placeholder="Search">
      </mat-form-field>

      <div>
        <table mat-table matSort matSortDisableClear [dataSource]="dataSource" table-striped style="width: 100%">
          @for (col of display_fields; track col; let i = $index) {
            <ng-container [matColumnDef]=col>
              @if (col === 'Download') {
                <th mat-header-cell class="table-header" *matHeaderCellDef>
                  <input id="mainBox" type="checkbox" [checked]="mainCheckboxChecked() == 2"
                    [indeterminate]="mainCheckboxChecked() == 1" (click)="mainCheckboxClicked()">
                  {{display_fields[i]}}
                </th>
                <td mat-cell class="table-cell-data" *matCellDef="let item">
                  <input type="checkbox" (click)="onCheckboxClick(item['Download'])"
                    [checked]="CheckboxChecked(item['Download'])">
                  @if (progress[item['Download']] >= 0) {
                    <mat-progress-bar mode="determinate" [value]="progress[item['Download']]">
                    </mat-progress-bar>
                  }
                </td>
              }
              @if (col !== 'Download') {
                <th mat-header-cell class="table-header" *matHeaderCellDef mat-sort-header [disabled]="mode === 'private'"> {{display_fields[i]}} </th>
                <td mat-cell class="table-cell-data" *matCellDef="let item">
                  @if (get_field_values_for_links(col)) {
                    @if (!isRecordPrivate(item)) {
                      <app-robust-link [prefix]="get_field_values_for_links(col)['prefix']"
                        [link]="item[get_field_values_for_links(col)['url']]"
                        [text]="item[col]">
                      </app-robust-link>
                    }
                    @if (isRecordPrivate(item)) {
                      <a [routerLink]="['/' + target_type, item[get_field_values_for_links(col)['url']]]">{{item[col]}}</a>
                      <i class="material-icons lock">lock</i>
                    }
                  }
                  @if (!get_field_values_for_links(col)) {
                    @switch (displayPlatformLogo(item, col)) {
                      @case ('nf-core') {
                        <img src="assets/logos/nf-core-logo.png" class="img-fluid pipeline-platform-logo" alt="nf-core">
                      }
                      @case ('Nextflow') {
                        <img src="assets/logos/nextflow-logo-dark.png" class="img-fluid pipeline-platform-logo" alt="nextflow">
                      }
                    }
                    @if (!displayPlatformLogo(item, col)) {
                      {{item[col]}}
                    }
                  }
                </td>
              }
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="display_fields"></tr>
          <tr mat-row *matRowDef="let row; columns: display_fields;"></tr>
        </table>
        <mat-paginator pageSize="10" [length]="totalHits"></mat-paginator>
      </div>

    </div>
  </div>
